// Small shared helpers for the manufacturing panels.

/** Readable message from a Laravel validation / abort response. */
export function apiError(e) {
  const data = e && e.response && e.response.data;
  if (!data) return 'Something went wrong. Check your connection and try again.';
  if (data.errors) {
    return Object.values(data.errors).flat().join(' ');
  }
  return data.message || data.error || 'Request failed.';
}

/** Up to 4 decimals, trailing zeros trimmed, thousands separated. */
export function fmtQty(n) {
  if (n === null || n === undefined || n === '') return '—';
  const v = Number(n);
  if (Number.isNaN(v)) return n;
  return v.toLocaleString(undefined, { maximumFractionDigits: 4 });
}

export function fmtMoney(n) {
  if (n === null || n === undefined || n === '') return '—';
  return Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
